import React from 'react';
import { ShowSection } from 'framework/ui/layout';
import { FormShowTemplate } from 'framework/form';
import WasteList from './List/WasteList';
import { useProjectFinanceService, useProjectDataContext, WASTE_STATUS_OPTIONS } from 'domain/shared/newProject';
import { EditableListFormShowTemplate } from 'framework/list';

const WasteContext = () => {
  const { wasteSearch } = useProjectFinanceService();
  const { data } = useProjectDataContext();

  return (
    <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
      <FormShowTemplate
        isInitialsLoadingPosition
        submitFormFunc={() => Promise.resolve()}
        afterSubmit={{
          message: 'You are awesome! The Waste has been successfully updated.',
        }}
        getDataFunc={async () => {
          const response = await wasteSearch({
            pageSize: 30,
            pageNumber: 0,
            filter: {
              davinciProjectId: {
                eq: data.id,
              },
            },
            sort: {
              createdAt: 'DESC',
            },
          });
          return {
            ...response,
            result: (response?.result ?? []).map((waste: { status: string }) => ({
              ...waste,
              statusLabel: waste.status ? (WASTE_STATUS_OPTIONS[waste.status] ?? waste.status) : 'Unknown',
            })),
          };
        }}
      >
        <EditableListFormShowTemplate listSource="result">
          <WasteList />
        </EditableListFormShowTemplate>
      </FormShowTemplate>
    </ShowSection>
  );
};

export default WasteContext;
